export const routes = [
  {
    path: "/gerenciar-meus-dados",
    component: () => import(/* webpackChunkName: "usuario" */ "./Index.vue")
  }
];
